import {ChangeEvent, ReactElement, useEffect, useMemo} from "react";
import {ReactComponent as SearchIcon} from "components/Icons/search.svg";
import {ReactComponent as CloseIcon} from "components/Icons/close.svg";
import {useIntl} from "react-intl";
import {connectMenu, connectSearchBox} from "react-instantsearch-dom";
import {MenuProvided, SearchBoxExposed, SearchBoxProvided} from "react-instantsearch-core";
import {debounce} from "debounce";
import {useAppDispatch, useAppSelector} from "lib/redux/hooks";
import {winePickerActions, winePickerSelectors} from "./winePickerSlice";

interface WinePickerSearchFieldComponentProps extends SearchBoxExposed {

}

function WinePickerSearchFieldComponent(props: WinePickerSearchFieldComponentProps & SearchBoxProvided): ReactElement {
    const intl = useIntl();

    const dispatch = useAppDispatch();
    const searchTerm = useAppSelector(winePickerSelectors.searchTerm);
    const setSearchTerm = (searchTerm: string) => dispatch(winePickerActions.setSearchTerm(searchTerm));

    const debouncedRefine = useMemo(() => {
        return debounce(props.refine, 150);
    }, [props.refine]);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setSearchTerm(e.target.value);
    };

    useEffect(() => {
        debouncedRefine(searchTerm);
    }, [debouncedRefine, searchTerm]);

    return (
        <div className="w-96 h-10 border border border-gray-1 rounded-lg
                       flex overflow-hidden
                       focus-within:border-focus">
            <RemoveCategoryRefinement attribute="category" update={searchTerm} />
            <input
                type="text"
                className="flex-auto self-stretch
                           appearance-none bg-warm-gray w-full h-full
                           py-2.5 px-3 pr-0
                           focus:outline-0 focus-visible:outline-0 active:outline-0"
                placeholder={intl.formatMessage({id: "winepicker.toolbar.search.placeholder"})}
                value={searchTerm}
                onChange={onChange}
            />
            <div className="flex-none self-center px-3 text-secondary leading-none">
                {searchTerm.length ? (
                    <button className="h-5 w-5" onClick={() => setSearchTerm("")}>
                        <CloseIcon className="h-5 w-5"/>
                    </button>
                ) : (
                    <SearchIcon/>
                )}
            </div>
        </div>
    );
}

export const WinePickerSearchField = connectSearchBox(WinePickerSearchFieldComponent);

interface RemoveCategoryRefinementComponentProps {
    update: any // clears category refinement on change of this propery
}

function RemoveCategoryRefinementComponent(props: RemoveCategoryRefinementComponentProps & MenuProvided): ReactElement | null {
    const dispatch = useAppDispatch();
    const {update, refine} = props;
    useEffect(() => {
        dispatch(winePickerActions.setCategory(null));
        refine(null);
    }, [dispatch, update, refine]);
    return null;
}

const RemoveCategoryRefinement = connectMenu(RemoveCategoryRefinementComponent);